import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State as EntityKeyState } from '@feature/pma-entity/reducers/entity-key.reducers';


export const selectEntityState = createFeatureSelector<EntityKeyState>('entityKey');

export const selectEntityKey = createSelector(
  [selectEntityState],
  (state: EntityKeyState) => {
    return state.entityKey
  }
);
